module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="additional_field ' +
((__t = ( is_required?'required':'not_required' )) == null ? '' : __t) +
'">\n	<input class="additional_input" type="text" placeholder="' +
((__t = ( placeholder_text )) == null ? '' : __t) +
'" />\n	<label>' +
((__t = ( label_text )) == null ? '' : __t) +
'</label>\n	<div class="validate" style="display:none;">' +
((__t = ( I18n.t('uploader.form.validate.additional_field') )) == null ? '' : __t) +
'</div>\n	<div class="error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n</div>';

}
return __p
}